<div class="sgt-produtividade-view sgt-view-layout">

    <div class="sgt-view-header">
        <nav class="sgt-header-breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">Produtividade</li>
            </ol>
        </nav>        
    </div>

    <div class="sgt-view-filter">
        <sgt-produtividade-filter
            #filterComponent
            (filterInitialized)="onFilterInitialized()"
            (filterChange)="onFilterChange()"
            (filterClear)="onFilterClear()">
        </sgt-produtividade-filter>
    </div>

    <div class="sgt-view-content">
        <router-outlet></router-outlet>
    </div>
</div>